'use strict';

var Clone = require('@hapi/hoek/lib/clone');
var Common = require('./common');
var internals = {
  annotations: Symbol('annotations')
};
exports.error = function (stripColorCodes) {
  if (!this._original || typeof this._original !== 'object') {
    return this.details[0].message;
  }
  var redFgEscape = stripColorCodes ? '' : "\x1B[31m";
  var redBgEscape = stripColorCodes ? '' : "\x1B[41m";
  var endColor = stripColorCodes ? '' : "\x1B[0m";
  var obj = Clone(this._original);
  for (var i = this.details.length - 1; i >= 0; --i) {
    // Reverse order to process deepest child first
    var pos = i + 1;
    var error = this.details[i];
    var path = error.path;
    var node = obj;
    for (var j = 0;; ++j) {
      var seg = path[j];
      if (Common.isSchema(node)) {
        node = node.clone(); // joi schemas are not cloned by hoek, we have to take this extra step
      }
      if (j + 1 < path.length && typeof node[seg] !== 'string') {
        node = node[seg];
      } else {
        var refAnnotations = node[internals.annotations] || {
          errors: {},
          missing: {}
        };
        node[internals.annotations] = refAnnotations;
        var cacheKey = seg || error.context.key;
        if (node[seg] !== undefined) {
          refAnnotations.errors[cacheKey] = refAnnotations.errors[cacheKey] || [];
          refAnnotations.errors[cacheKey].push(pos);
        } else {
          refAnnotations.missing[cacheKey] = pos;
        }
        break;
      }
    }
  }
  var replacers = {
    key: /_\$key\$_([, \d]+)_\$end\$_"/g,
    missing: /"_\$miss\$_([^|]+)\|(\d+)_\$end\$_": "__missing__"/g,
    arrayIndex: /\s*"_\$idx\$_([, \d]+)_\$end\$_",?\n(.*)/g,
    specials: /"\[(NaN|Symbol.*|-?Infinity|function.*|\(.*)]"/g
  };
  var message = internals.safeStringify(obj, 2).replace(replacers.key, function ($0, $1) {
    return "\" ".concat(redFgEscape, "[").concat($1, "]").concat(endColor);
  }).replace(replacers.missing, function ($0, $1, $2) {
    return "".concat(redBgEscape, "\"").concat($1, "\"").concat(endColor).concat(redFgEscape, " [").concat($2, "]: -- missing --").concat(endColor);
  }).replace(replacers.arrayIndex, function ($0, $1, $2) {
    return "\n".concat($2, " ").concat(redFgEscape, "[").concat($1, "]").concat(endColor);
  }).replace(replacers.specials, function ($0, $1) {
    return $1;
  });
  message = "".concat(message, "\n").concat(redFgEscape);
  for (var _i = 0; _i < this.details.length; ++_i) {
    var _pos = _i + 1;
    message = "".concat(message, "\n[").concat(_pos, "] ").concat(this.details[_i].message);
  }
  message = message + endColor;
  return message;
};

// Inspired by json-stringify-safe

internals.safeStringify = function (obj, spaces) {
  return JSON.stringify(obj, internals.serializer(), spaces);
};
internals.serializer = function () {
  var keys = [];
  var stack = [];
  var cycleReplacer = function cycleReplacer(key, value) {
    if (stack[0] === value) {
      return '[Circular ~]';
    }
    return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
  };
  return function (key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this);
      if (~thisPos) {
        stack.length = thisPos + 1;
        keys.length = thisPos + 1;
        keys[thisPos] = key;
      } else {
        stack.push(this);
        keys.push(key);
      }
      if (~stack.indexOf(value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }
    if (value) {
      var annotations = value[internals.annotations];
      if (annotations) {
        if (Array.isArray(value)) {
          var annotated = [];
          for (var i = 0; i < value.length; ++i) {
            if (annotations.errors[i]) {
              annotated.push("_$idx$_".concat(annotations.errors[i].sort().join(', '), "_$end$_"));
            }
            annotated.push(value[i]);
          }
          value = annotated;
        } else {
          for (var errorKey in annotations.errors) {
            value["".concat(errorKey, "_$key$_").concat(annotations.errors[errorKey].sort().join(', '), "_$end$_")] = value[errorKey];
            value[errorKey] = undefined;
          }
          for (var missingKey in annotations.missing) {
            value["_$miss$_".concat(missingKey, "|").concat(annotations.missing[missingKey], "_$end$_")] = '__missing__';
          }
        }
        return value;
      }
    }
    if (value === Infinity || value === -Infinity || Number.isNaN(value) || typeof value === 'function' || typeof value === 'symbol') {
      return '[' + value.toString() + ']';
    }
    return value;
  };
};